import config from "../components/config";
export const checkUser = () => {
  return !!config.AUTH.DRIVER.getItem("user");
};
